import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { Box, Tab, Select, MenuItem } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';

import Chart from "react-apexcharts";

import VulnerabilityTrendAnalysis  from "./VulnerabilityTrendAnalysis";
import { fetchAlertAnalysisById as fetchAlertsAnalysisService} from "services/modules/vapt/data";
import { fetchSingleCompany as fetchSingleCompanyService } from "services/modules/idp/company";
import { setLoading } from 'stores/modules/idp/authreducer';


const CurrentAnalysis = (props) => {
  // Redux dispatch
  const dispatch = useDispatch();
  
  // Redux selectors
  const categoriesContainer = useSelector((state) => state.vaptData.dimensions);
  const dimensionsContainer=useSelector((state) => state.vaptData.dimensions);
  const selectedCompanyContainer = useSelector((state) => state.auth.companyData );
  const severitiesContainer = useSelector(state => state.vaptData.severities);
  const companyContainer = useSelector(state => state.company.singleCompany);
  
  // State variables
  let allFiltersData = [
    {
      label: "Last 1 Month",
      value: 1,
    },
    {
      label: "Last 3 Months",
      value: 3,
    },
    {
      label: "Last 6 Months",
      value: 6,
    },
    {
      label: "Last 9 months",
      value: 9,
    },
    {
      label: "Last 12 months",
      value: 12,
    },
  ];
  const [value, setValue] = React.useState('1');
  const [alertAnalysis, setAlertsAnalysis] = useState([]);
  const [filters, setfiltersData] = useState(allFiltersData);
  const [activeFilter, setActiveFilter] = useState(1);

  // Current Analysis graph 
  let chartstate = {
    options: {
      colors: ["#2fc430", "#4baeec", "#4c4ccc", "#fc659c", "#eb4b2c"], 
      chart: {
        fontFamily: 'Montserrat, Open Sans, sans-serif',
        type: "bar",
        height: 275,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        labels: {
          rotate: -45,
          hideOverlappingLabels: false,
        },
      },
      yaxis: {
        title: {
          text: "Findings Count",
        },
        min: 0,
        max: 20
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if(val > 20){
              return 20 + "+ Finding(s)";
            }
            else{
              return val + " Finding(s)";
            }
          },
        },
      },
      legend: {
        position: "top",
      },
    },
    series: [
      {
        name: "Informational",
        data: [],
      },
      {
        name: "Low",
        data: [],
      },
      {
        name: "Medium",
        data: [],
      },
      {
        name: "High",
        data: [],
      },
      {
        name: "Critical",
        data: [],
      },
    ],
  };
  const [currentAnalysisChatOptions, setCurrentAnalysisChatOptions] = useState(chartstate);
  
  // Handles classification of alerts based on severity and dimension in case if category is not compliance and sets to chartstate
  useEffect(() => {
    if (alertAnalysis && alertAnalysis.length > 0){
        const series = severitiesContainer?.map((severity) => ({
                        name: severity.label,
                        data: [],
                      }));        
        alertAnalysis.forEach((dat) => {
          severitiesContainer.forEach((severity) => {
            const severityIndex = series.findIndex(
              (severe) => severe.name === severity.label
            )
            series[severityIndex]?.data?.push(dat?.count[severity?.slug] === 0 ? 0 : dat.count[severity?.slug])
          });
        });

        let categories = alertAnalysis?.map((dat) =>
            dat.category.label.split(" ")
          );
        categories = categories.map((cat) => {
          if (cat[1] === "Reconnaissance") {
            return [cat[0], "Reconn-", "aissance"];
          }
          return cat;
        });
        chartstate.options = {
          ...chartstate.options,
          xaxis: { ...chartstate.options.xaxis, categories },
        };
        chartstate.series = series;
        chartstate.options.chart['events']= {
          dataPointSelection: (event, chartContext, config) => {
          }
        }
        setCurrentAnalysisChatOptions(chartstate); 
    }
    else{
      let chartstate = {
        options: {
          colors: ["#2fc430", "#4baeec", "#4c4ccc", "#fc659c", "#eb4b2c"], 
          chart: {
            fontFamily: '"Montserrat", "Open Sans", sans-serif',
            type: "bar",
            height: 275,
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          xaxis: {
            labels: {
              rotate: -45,
              hideOverlappingLabels: false,
            },
          },
          yaxis: {
            title: {
              text: "Findings Count",
            },
            min: 0,
            max: 20
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                if(val > 20){
                  return 20 + "+ Finding(s)";
                }
                else{
                  return val + " Finding(s)";
                }
              },
            },
          },
          legend: {
            position: "top",
          },
        },
        series: [
          {
            name: "Informational",
            data: [],
          },
          {
            name: "Low",
            data: [],
          },
          {
            name: "Medium",
            data: [],
          },
          {
            name: "High",
            data: [],
          },
          {
            name: "Critical",
            data: [],
          },
        ],
      };
      setCurrentAnalysisChatOptions(chartstate)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertAnalysis]);
  
  // useEffect fetches alert analysis data based on category and sets the active date to report date incase if alert analysis data is present else sets the active date to current date
  useEffect(() => {
    const fetchCurrrentAnalysisData = async() => {
      let params = {
        "id":selectedCompanyContainer?.companyid
      }
      dispatch(setLoading(true));     
      const response = await fetchAlertsAnalysisService({ params });
      setAlertsAnalysis(response)
      dispatch(setLoading(false));
    };
    const fetchCompanyData = async() => {
      dispatch(setLoading(true));
      const companyId = selectedCompanyContainer.companyid;
      dispatch(fetchSingleCompanyService({ companyId }));      
      dispatch(setLoading(false));
    };

    if (dimensionsContainer && (dimensionsContainer.length>0) && categoriesContainer && categoriesContainer.length > 0){
      dispatch(setLoading(true));
      fetchCompanyData()
      fetchCurrrentAnalysisData();
      dispatch(setLoading(false));
    }
    else{
      setAlertsAnalysis([]);
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimensionsContainer, categoriesContainer]);
  

  // Sets the filter based on company created date
  useEffect(() => { 
    if (companyContainer){
      let filtersData = [];
      setActiveFilter(1); 
      if (companyContainer.createdAt){
        const companyCreatedAt = new Date(companyContainer.createdAt);        
        const d = new Date();     
        const months =d.getMonth() -companyCreatedAt.getMonth() +12 * (d.getFullYear() - companyCreatedAt.getFullYear()) +1;
        const diff_days = Math.round((d - companyCreatedAt)/(1000*60*60*24));   
        let filtersIndex = allFiltersData.findIndex(
          (dat) => dat.value >= months
        );
        if (months > 12) {
          filtersIndex = allFiltersData.length - 1;
        }
        filtersData = allFiltersData.slice(0, filtersIndex + 1);
        let allFiltersOptions = [
        {
            label: "Last 1 Week",
            value: 7,
          },
          {
            label: "Last 2 Weeks",
            value: 14,
          },
          {
            label: "Last 3 Weeks",
            value: 21,            
          },
          {
            label: "Last 6 Weeks",
            value: 42,
          }
          ];
        filtersIndex = allFiltersOptions.findIndex(
          (dat) => dat.value >= diff_days
        );
        if (diff_days > 43) {
          filtersIndex = allFiltersOptions.length - 1;
        }
        filtersData = [...allFiltersOptions.slice(0, filtersIndex+1), ...filtersData];
        setfiltersData(filtersData);
      }
      else{
        setfiltersData(allFiltersData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyContainer]);
  

  // Handles change in filter values
  const handleDropdownChange = (event) => {
    const selectedValue = parseInt(event.target.value);
    setActiveFilter(selectedValue);
  };

  return (
    <div>
      <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <div className='d-flex justify-content-around'>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', width:'75%' }}>
            <TabList onChange={(e,val) => setValue(val)} className='overall-dashboard-tab'>
              <Tab label="Current Analysis" value="1" />
                 <Tab label="Vulnerability Trend Analysis" value="2"/> 
            </TabList>
          </Box>
          {value === "2" ? (
            <Select
              variant="outlined"
              color="primary"
              value={activeFilter}
              onChange={handleDropdownChange}
              size="small"
            >
              {filters.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          ): (
            <>
            </>
          )}
        </div>           
        <TabPanel value="1">
          <Chart
            options={currentAnalysisChatOptions?.options} 
            series={currentAnalysisChatOptions?.series}
            type="bar"
            height="250"
          />
        </TabPanel>
        <TabPanel value="2">
          <VulnerabilityTrendAnalysis activeFilter={activeFilter} />
        </TabPanel>
      </TabContext>
    </Box>
    </div>
  )
}

export default CurrentAnalysis;